import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import * as firebase from 'firebase';
import 'firebase/firestore'
import firebase from 'firebase/app'


// var firebaseConfig = {
//   apiKey: "AIzaSyAZxEY5MJyAgu5Eta8cGk9JxLSvNp9PL5U",
//   authDomain: "breeze-b933b.firebaseapp.com",
//   databaseURL: "https://breeze-b933b.firebaseio.com",
//   projectId: "breeze-b933b",
//   storageBucket: "breeze-b933b.appspot.com",
//   messagingSenderId: "52860641709",
//   appId: "1:52860641709:web:705b28bb0f6946d8008124",
//   measurementId: "G-79BZE0QM7K"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export default firebase